import React from "react";

const PrivacyPolicy = () => {
  const points = [
    "The platform collects basic Google account information, such as name and email address, upon user authentication.",
    "Business listing data including name, location, category, and business hours is accessed through Google APIs with user consent.",
    "Public reviews associated with the connected business listings are fetched to display within the platform dashboard.",
    "Users may flag individual reviews for moderation, providing reasons for potential removal or rejection.",
    "No collected data is shared with third parties or advertisers under any circumstances.",
    "The platform uses HTTPS encryption and secure data storage practices to protect all user and business data.",
    "Access to personal and business information is strictly limited to authenticated users and authorized administrators.",
    "Users can revoke access to their Google account at any time through the dashboard or directly from their Google account settings.",
    "Upon revocation, all synced data associated with the user's account will be deleted from our systems.",
    "The platform adheres to international data protection standards and does not store or process sensitive user data beyond operational requirements.",
    "Users may request the permanent deletion of their account and all associated data by contacting the support team.",
  ];

  return (
    <section className="bg-gray-50 py-20 px-6 md:px-24">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-2xl p-10">
        <h1 className="h1-mb h1-md h1-lg h1-2xl">
          Privacy Policy
        </h1>
        <ul className="space-y-4 list-decimal list-inside text-gray-700 text-lg">
          {points.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
        <p className="text-sm text-gray-500 mt-10 text-center italic">
          Last updated: July 24, 2025
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
